import styled from "styled-components";

const FormField = styled.div``;

export { FormField };
